import { render } from "./Compliment.vue?vue&type=template&id=2bc210e4"
import script from "./Compliment.vue?vue&type=script&lang=js"
export * from "./Compliment.vue?vue&type=script&lang=js"

import "./Compliment.vue?vue&type=style&index=0&id=2bc210e4&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "2bc210e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bc210e4', script)) {
    api.reload('2bc210e4', script)
  }
  
  module.hot.accept("./Compliment.vue?vue&type=template&id=2bc210e4", () => {
    api.rerender('2bc210e4', render)
  })

}

script.__file = "src/views/Compliment.vue"

export default script